export default "__VITE_ASSET__11cu7UNc__"